export default "__VITE_ASSET__22211e62__"